import { Colorpicker, ColorpickerEvents } from "@dhx/ts-colorpicker";
import { el } from "@dhx/ts-common/dom";
import { validate } from "../validate";
import { getIconGroup, getSelect } from "./helpers";
import { Text } from "./Text";
import { Popup } from "@dhx/ts-popup";

export class TextProps extends Text {
	private _colorPicker: Colorpicker;
	private _popup: Popup;

	constructor(config, ev) {
		config.validation = config.validation || "color";
		super(config, ev);
		this._colorPicker = new Colorpicker(null);
		this._popup = new Popup();
		this._popup.attach(this._colorPicker);
		this._colorPicker.events.on(ColorpickerEvents.change, fontColor => {
			this._popup.hide();
			if (this._config.value.fontColor !== fontColor) {
				this.setValue({ ...this._config.value, fontColor });
			}
		});
		this._handlers.show = e => this._showPopup(e.target);
		this._handlers.change = e => {
			const val = e.target.value;
			if (validate(val, "number")) {
				e.target.setAttribute("class", "");
				this.setValue({ ...this._config.value, lineHeight: val });
			} else {
				e.target.setAttribute("class", "dhx_invalid");
			}
		};
		this._handlers.onSelect = (id, val) => {
			this.setValue({ ...this._config.value, [id]: val });
		};
		this._handlers.iconClick = (id, e) => {
			const val = e.target.getAttribute("dhx_id");
			this.setValue({ ...this._config.value, [id]: val });
		};
	}
	toVDOM() {
		return el(".edit-section.line-edit", { _key: this._uid }, [
			el(".section-title", this._config.label || ""),

			el(".line-edit-content", [
				el(
					".dropup.input_element",
					getSelect(
						this._handlers.onSelect,
						"fontSize",
						[
							{ id: "10", text: "10" },
							{ id: "12", text: "12" },
							{ id: "14", text: "14" },
							{ id: "16", text: "16" },
							{ id: "18", text: "18" },
							{ id: "20", text: "20" },
						],
						parseFloat(this._config.value.fontSize).toString() || "14"
					)
				),
				el(".input_element.line_height", [
					el("input", {
						type: "text",
						_ref: this._uid,
						onchange: this._handlers.change,
						oninput: this._handlers.change,
						value: this._config.value.lineHeight,
						_key: "line_height",
					}),
					el(".input_icon_wrap", [el(".dxi.dxi-format-line-spacing")]),
				]),
				getIconGroup(
					this._handlers.iconClick,
					"fontWeight",
					[{ id: "bold", css: "dxi dxi-format-bold" }],
					this._config.value.fontWeight,
					true
				),
				getIconGroup(
					this._handlers.iconClick,
					"fontStyle",
					[{ id: "italic", css: "dxi dxi-format-italic" }],
					this._config.value.fontStyle,
					true
				),
			]),
			el(".line-edit-content", [
				el(
					".input_element.alone_picker",
					{
						onclick: this._handlers.show,
					},
					[
						el(".input_icon_wrap", [
							el(".input_icon", {
								style: {
									backgroundColor: this._config.value.fontColor,
								},
							}),
						]),
					]
				),
				this._config.alignments !== false &&
					getIconGroup(
						this._handlers.iconClick,
						"textAlign",
						[
							{ id: "left", css: "dxi dxi-format-align-left" },
							{ id: "center", css: "dxi dxi-format-align-center" },
							{ id: "right", css: "dxi dxi-format-align-right" },
						],
						this._config.value.textAlign
					),
				this._config.alignments !== false &&
					this._config.verticalAlignments !== false &&
					getIconGroup(
						this._handlers.iconClick,
						"textVerticalAlign",
						[
							{ id: "top", css: "dxi dxi-format-vertical-align-top" },
							{ id: "center", css: "dxi dxi-format-vertical-align-center" },
							{ id: "bottom", css: "dxi dxi-format-vertical-align-bottom" },
						],
						this._config.value.textVerticalAlign
					),
			]),
		]);
	}
	private _showPopup(node: any) {
		this._colorPicker.setValue(this._config.value.fontColor);
		this._popup.show(node);
	}
}
